<template>
  <div class="body">
        <p  class="font1" style="padding-top: 8vh;color: #e06c24;">白日依山尽，黄河入海流</p>
        <p  class="font1" style="padding-top: 1vh;color: #e06c24;">欲穷千里目，更上一层楼</p>
        <p class="font2" style="padding-top: 5vh;">2024年第三季度你的个人发展与成长：</p>
        <p class="font2" v-if="this.count!=0" style="padding-top: 1vh;"> <i class="fa fa-check"></i>完成了<a class="font3">{{ this.count }}</a>个认证培训项目学习</p>
        <p class="font2" v-if="this.count1!=0"> <i class="fa fa-check"></i>获得了<a class="font3">{{ this.count1 }}</a>个证书</p>
        <p class="font2" v-if="this.course.length!==0"> <i class="fa fa-check"></i>参与了<a class="font3">{{ this.course.join('、') }}</a></p>
        <!-- <p class="font2" v-if="this.promote!==''"> <i class="fa fa-check"></i>顺利晋升为<a class="font3">{{ this.promote }}</a></p> -->
        <p class="font2" v-if="this.teacher!==''"> <i class="fa fa-check"></i>通过讲师认证，成为<a class="font3">{{ this.teacher }}</a></p>         
        <p class="font2" style="padding-top: 4vh;margin: 0;">鹰击长空壮，鹏飞海浪春</p>
       
  </div>
</template>

<script>
export default {
    props:['ReportData'],
    data(){
        return {
            activityArray:[],
            course:[],
            promote:'',
            teacher:'',
            count:0,
            count1:0,
        }
    },
    created(){
        const activityArray = JSON.parse(this.ReportData.activity2)
        const activityArray1 = JSON.parse(this.ReportData.activity)
        if(activityArray1 != null){
            this.count=activityArray1.length
        }
        if(activityArray1 != null){
            activityArray1.forEach(element => {
                if(element.name=='讲师评审'){
                    this.teacher=element.certificate
                }else if(element.name=='晋升'){
                    this.promote=element.certificate
                }else{
                    this.course.push(element.name)
                }
            });
        }
        if(activityArray1 != null){
            activityArray1.forEach(element => {
                if (element.certificate!=='无') {
                    this.count1++
                }
            });
        }
       
       
    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24June/logo.png") right  top  no-repeat,
                url("../../assets//24September/icon.png") 40% calc(100%) no-repeat,
                url("../../assets/24September/bg.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px, 68%,cover;
    width: 100%;
    height: 100vh;
}
.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 18px;
    color: #000;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 92%;
    padding-left: 8%;
    margin: 0;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>